<template>
  <v-card outlined class="elevation-0 mx-4">
    <v-data-table
      :headers="headers"
      :items="departments"
      :loading="loading"
      class="elevation-0 mt-0"
      :footer-props="{
        itemsPerPageText: 'Số dòng mỗi trang:',
        itemsPerPageAllText: 'Tất cả',
      }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="mr-2" @click="$emit('edit', item)"> mdi-pencil </v-icon>
        <v-icon @click="$emit('delete', item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'DepartmentTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    departments: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    }
  },
}
</script>

<style scoped>
.v-data-table {
  margin-top: 20px;
}
</style>
